<template>
  <div class="home-section3">
    <div class="section3-title">
      <div></div>
      <div></div>
      <img src="../../../assets/image/home-matrix-icon.png" alt="职业矩阵" />
      <span>职业矩阵</span>
    </div>
    <div class="section-content">
      <div class="image-box">
        <img v-if="matrixInfo.img1" :src="matrixInfo.img1" alt="职业矩阵" class="content-image" @click="toTemp(6)" />
      </div>
      <div class="image-box">
        <img v-if="matrixInfo.img2" :src="matrixInfo.img2" alt="职业矩阵" class="content-image" @click="toTemp(7)" />
      </div>
      <div class="image-box">
        <img v-if="matrixInfo.img3" :src="matrixInfo.img3" alt="职业矩阵" class="content-image" @click="toTemp(8)" />
      </div>
    </div>
  </div>
</template>
<script>
import { getCareerMatrixImage } from '../../../api/careerMatrix'

export default {
  name: 'HomeSection3',

  data() {
    return {
      matrixInfo: {}
    }
  },
  created() {
    getCareerMatrixImage().then(({ code, data }) => {
      if (code === 0) {
        this.matrixInfo = data
      }
    })
  },
  methods: {
    toTemp(type) {
      this.$router.push(`/careerMatrix/${type}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.home-section3 {
  margin-bottom: 70px;
  .section3-title {
    position: relative;
    height: 52px;
    border-bottom: 1px dashed #c6c6c6;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    > div:first-child {
      position: absolute;
      top: 0;
      left: 18px;
      width: 126px;
      height: 4px;
      background: #ff4e4e;
    }
    > div:nth-child(2) {
      position: absolute;
      top: 0;
      left: 144px;
      width: 1054px;
      height: 2px;
      background: #085dc8;
      opacity: 0.35;
    }
    > img {
      width: 30px;
      height: 30px;
      margin: 0 10px 0 16px;
    }
  }
  .section-content {
    margin: 0 -6px;
    height: 288px;
    .image-box {
      display: inline-block;
      vertical-align: middle;
      width: 392px;
      height: 288px;
      box-sizing: border-box;
      margin: 0 6px;
      font-size: 0;
      cursor: pointer;
      .content-image {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
